import { motion } from "framer-motion";

export const QuestionCard = ({ entry }) => (
  <motion.div
    initial={false}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: "easeOut" }}
    data-testid="question-card"
  >
    <p data-testid="question-text-en" className="font-marquee text-2xl leading-snug text-white sm:text-3xl">
      “{entry.english_question}”
    </p>
    {entry.hindi_question && (
      <p data-testid="question-text-hi" className="font-hindi mt-3 text-xl text-[var(--hindi)] sm:text-2xl">
        {entry.hindi_question}
      </p>
    )}
  </motion.div>
);
